import { useRef } from 'react';
import { Button } from '#components/atoms/buttons/Button.tsx';
import { ConfirmButtonGroup } from '#components/patterns/confirmations/confirm-button-group/ConfirmButtonGroup.tsx';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '#components/patterns/modal/index.ts';
import { FirewallRuleForm } from '../firewall-rule-form/FirewallRuleForm.tsx';
import type { FirewallRuleFieldValue } from '../types.ts';

type Props = {
  onSave: (firewallRule: FirewallRuleFieldValue) => void;
  onClose: () => void;
  firewallRule: FirewallRuleFieldValue;
};

/**
 * {@link EditFirewallRuleModal} shows a form for editing an existing firewall rule
 */
export function EditFirewallRuleModal({ onSave, onClose, firewallRule }: Props) {
  const modalRef = useRef(null);

  return (
    <Modal ref={modalRef} isOpen={true} onClose={onClose}>
      <ModalHeader>Edit inbound firewall rule</ModalHeader>
      <ModalBody>
        <FirewallRuleForm rule={firewallRule} onSave={onSave} />
      </ModalBody>
      <ModalFooter>
        <ConfirmButtonGroup
          variant="right"
          primaryButton={
            <Button type="submit" form="firewall-rule-form">
              Save
            </Button>
          }
          secondaryButton={
            <Button variant="link" onClick={() => onClose()}>
              Cancel
            </Button>
          }
        />
      </ModalFooter>
    </Modal>
  );
}
